import LocationWidget from './LocationWidget';

export default LocationWidget;
